<template>
  <div>
    [WrapLayout]
    <slot name="default"></slot>
  </div>
</template>

<script>

export default {

}

</script>

<style>

</style>